// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3n94S","unreadBadge":"styles_unreadBadge__29XbQ","modalContent":"styles_modalContent__2CloJ","modal":"styles_modal__UBtoz"};